<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="3">
          <v-text-field
            :value="collectionMonthlyTransaction.link"
            id="collectionsMonthlyTransItemLinkText"
            class="collections-monthly-trans-item-link-text"
            label="Link"
           @input="emitCollectionInfo({ link: $event })"
           readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            :value="collectionMonthlyTransaction.saiSection"
            id="collectionsMonthlyTransItemSAISectionText"
            class="collections-monthly-trans-item-sai-section-text"
            label="SAI Section"
           @input="emitCollectionInfo({ saiSection: $event })"
           readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            :value="collectionMonthlyTransaction.unapportionLastMonth"
            id="collectionsMonthlyTransItemUnapportionLastMonthtText"
            class="collections-monthly-trans-item-unapportion-last-month-text"
            label="Unapportion Last Month"
           @input="emitCollectionInfo({ unapportionLastMonth: $event })"
           readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            :value="collectionMonthlyTransaction.receipts"
            id="collectionsMonthlyTransItemReceiptsText"
            class="collections-monthly-trans-item-receipts-text"
            label="Collections"
           @input="emitCollectionInfo({ receipts: $event })"
           readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-text-field
            :value="collectionMonthlyTransaction.transferIn"
            id="collectionsMonthlyTransItemTransferInText"
            class="collections-monthly-trans-item-transfer-in-text"
            label="Transfer In "
           @input="emitCollectionInfo({ transferIn: $event })"
           readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            :value="collectionMonthlyTransaction.transferOut"
            id="collectionsMonthlyTransItemransferOutText"
            class="collections-monthly-trans-transfer-out-text"
            label="Transfer Out"
           @input="emitCollectionInfo({ transferOut: $event })"
           readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            :value="collectionMonthlyTransaction.refundsPaymentCancelled"
            id="collectionsMonthlyTransItemRefundsPaymentCancelledText"
            class="collections-monthly-trans-refunds-payment-cancelled-text"
            label="Payment Refunds Cancel"
           @input="emitCollectionInfo({ refundsPaymentCancelled: $event })"
           readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            :value="collectionMonthlyTransaction.total"
            id="collectionsMonthlyTransItemTotalText"
            class="collections-monthly-trans-item-total-text"
            label="Total"
           @input="emitCollectionInfo({ total: $event })"
           readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-text-field
            :value="collectionMonthlyTransaction.apportioned"
            id="collectionsMonthlyItemApportionedText"
            class="collections-monthly-trans-item-apportioned-text"
            label="Apportioned"
           @input="emitCollectionInfo({ apportioned: $event })"
           readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            :value="collectionMonthlyTransaction.balanceUnapportioned"
            id="collectionsMonthlyTransItemBalanceUnapportionedText"
            class="collections-monthly-trans-item-balance-unapportioned-text"
            label="Balance Unapportioned"
           @input="emitCollectionInfo({ balanceUnapportioned: $event })"
           readonly
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

// const amountFields = ['unapportionLastMonth',
// 'receipts', 'transferIn', 'transferOut', 'refundsPaymentCancelled',
// 'total', 'apportioned', 'balanceUnapportioned', 'saiSection'];

export default {
  name: 'CollectionsMonthlyTransaction',
  components: {
  },
  props: {
    collectionMonthlyTransaction: {
      type: Object,
      default: () => ({}),
    },
  },
  created() {
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'items',
      'index',
      'isVisible',
    ]),
  },
  methods: {
    emitCollectionInfo(updates) {
      this.$emit('updateCollectionsMonthlyTransaction', {
        ...this.collectionMonthlyTransaction,
        ...updates,
      });
    },
    /*
     will develop more on this
      roundAmountFields() {
        console.info(this.collectionMonthlyTransaction, 'collectionMonthlyTransaction');
        // return amountFields.forEach((f) => {
      //   this.collectionMonthlyTransaction[f] = amountFormat(
      //     amountToNumber(this.collectionMonthlyTransaction[f]),
      //   );
      // });
    */
  },
};
</script>
